import { render } from "./owners-with-bank-account-card.vue?vue&type=template&id=32a1dd5a"
import script from "./owners-with-bank-account-card.vue?vue&type=script&lang=js"
export * from "./owners-with-bank-account-card.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__